<mat-card appearance="outlined" class="admin-settings-faq">
  <mat-card-header>
    <mat-card-title>
      <span>
        {{ 'TRANS__ADMIN_SETTINGS__TITLE_FAQ' | translate }}
      </span>
    </mat-card-title>
  </mat-card-header>

  <mat-accordion [multi]="false">
    @for (fq of adminSettingsFq; track $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          {{fq.question}}
        </mat-expansion-panel-header>

        <span>
          {{fq[AConst.ANSWER]}}
        </span>

        @if (fq.url) {
          <a target="_blank" [href]="fq.url">
            {{fq.url}}
          </a>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</mat-card>
